import { $ } from '../utils/Utils';

const imgSwitch = (() => {
  const config = {
    triggers: [...$('.js-imgSwitchTrigger')],
    targets: [...$('.js-imgSwitchTarget')],
    fadeOutCN: '-fadeOut',
    fadeInCN: '-fadeIn',
  };

  const handleClick = (trigger) => {
    const index = parseFloat(trigger.dataset.index);

    // sort images to know which ones to hide and show
    config.targets.forEach((target) => {
      const targetIndex = parseFloat(target.dataset.index);
      if (targetIndex === index) {
        // this is the one to show
        target.classList.remove(config.fadeOutCN);
        target.classList.add(config.fadeInCN);
      } else {
        target.classList.remove(config.fadeInCN);
        target.classList.add(config.fadeOutCN);
      }
    });
  };

  const build = () => {
    config.triggers.forEach((trigger) => {
      trigger.addEventListener('focus', () => handleClick(trigger));
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default imgSwitch.init();
